var data = {};

var getCookie = function (name) {
    var matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
};

var setCookie = function (name, value, options) {
    options = options || {};

    var expires = options.expires;

    if (typeof expires === "number" && expires) {
        var d = new Date();
        d.setTime(d.getTime() + expires * 1000);
        expires = options.expires = d;
    }
    if (expires && expires.toUTCString) {
        options.expires = expires.toUTCString();
    }

    value = encodeURIComponent(value);

    var updatedCookie = name + "=" + value;

    for (var propName in options) {
        updatedCookie += "; " + propName;
        var propValue = options[propName];
        if (propValue !== true) {
            updatedCookie += "=" + propValue;
        }
    }

    document.cookie = updatedCookie;
};

if(typeof unique === 'undefined')
    var unique = 0;

var loadJSONP = (function () {
    return function (url, callback, context) {
        // INIT
        var name = "_jsonp_" + 10;
        if (url.match(/\?/)) url += "&callback=" + name;
        else url += "?callback=" + name;

        // Create script
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;

        // Setup handler
        window[name] = function (data) {
            callback.call((context || window), data);
            document.getElementsByTagName('head')[0].removeChild(script);
            script = null;
            delete window[name];
        };

        // Load JSON
        document.getElementsByTagName('head')[0].appendChild(script);
    };
})();

var parseForm = function (id) {
    var form = document.getElementById(id);
    var inputs = form.querySelectorAll('input');
    inputs.forEach(function (input) {
        if (input.type === 'radio') {
            if (input.checked) {
                data[input.name] = input.value;
            }
        } else if (input.type !== 'submit') {
            data[input.name] = input.value;
        }
    });
    var selects = form.querySelectorAll('select');
    selects.forEach(function (select) {
        data[select.name] = select.value;
    });
}

var showPopup = function (popup) {
  document.querySelector('html').addEventListener("click", function (e) {
    if (e.target.classList.contains('popup-close')) {
        var dataHref = e.target.getAttribute('data-href');
        if(dataHref)
            e.target.setAttribute('href', dataHref);
        else
            e.preventDefault();
        hidePopup(popup);
    }
});
    var popupEl = document.getElementById('popup');
    if (popupEl === null || popupEl.classList.contains('active')) {
        return;
    }
    if (getCookie('popup#' + popup.id) === 'true') {
        return;
    }
    if (popup.first_time && getCookie('popup') === 'true') {
        return;
    }
    setCookie('popup#' + popup.id, true, {expires: popup.repeat_in, path: '/'});
    setCookie('popup', true, {expires: 31556926, path: '/'});
    popupEl.innerHTML = popup.html;
    popupEl.classList.add('active');
    document.querySelector('body').classList.add('scroll-hide');

    document.getElementById('popupForm').addEventListener("submit", function (e) {
        e.preventDefault();
        parseForm('popupForm');
        var request = new XMLHttpRequest();
        request.open('POST', '//apps.zinvowatches.com/popups/public/api/popup_data/' + popup.id, true);
        request.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
        request.onreadystatechange = function() {
            if (request.readyState == XMLHttpRequest.DONE) {
                var response = JSON.parse(request.response);
                if (popup.result_active) {
                    showResultPopup(popup, response.success, data);
                } else {
                    hidePopup(popup);
                }
            }
        }
        request.send(JSON.stringify({ data: data }));

    });
};

var showResultPopup = function(popup, success, data) {
    if (success) {
        document.getElementById('popup').innerHTML = popup.success_html;
      if (document.getElementById('popupComplementForm') != null) {
        document.getElementById('popupComplementForm').addEventListener("submit", function (e) {
            e.preventDefault();
            hidePopup(popup);
        });
      }
        
    } else {
        document.getElementById('popup').innerHTML = popup.error_html;
    }
    setTimeout(function (popup) {
        hidePopup(popup);
    }, popup.close_time * 1000, popup);
}

var hidePopup = function (popup) {
    if (document.getElementById('popupComplementForm') != null) {
        parseForm('popupComplementForm');
    }
  if (JSON.stringify(data) !== JSON.stringify({})) {
    var request = new XMLHttpRequest();
    request.open('POST', '//apps.zinvowatches.com/popups/public/api/popup_data/' + popup.id + '/complement', true);
    request.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
    request.onreadystatechange = function() {}
    request.send(JSON.stringify({ data: data }));
  }
    
    var popupEl = document.getElementById('popup');
    popupEl.classList.remove('active');
    popupEl.innerHTML = '';
    document.querySelector('body').classList.remove('scroll-hide');
};

loadJSONP(
    '//apps.zinvowatches.com/popups/public/api/popups/' + Shopify.shop,
    function (res) {
        if (typeof res.success !== 'undefined' && !res.success) {
            console.error(res.msg);
        }
        if (typeof res.popups !== 'undefined') {
            res.popups.forEach(function (popup) {
                if (window.location.href.search(popup.url_regex) !== -1) {
                    if (popup.on_enter) {
                        setTimeout(function (popup) {
                            showPopup(popup);
                        }, popup.on_enter_delay * 1000, popup);
                    }

                    if (popup.on_exit) {
                        document.querySelector('html').addEventListener("mouseleave", function (e) {
                            e.stopPropagation();
                            showPopup(popup);
                        });
                    }
                }
            });
        }
    }
);